import { css } from "styled-components";

export const responsiveThemeGrid = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  ${props => props.theme.breakpoints.down("sm")} {
    display: block;
  }
`;
